import { AppBar, Grid, Stack, Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { HelpAndService } from './helpAndService';
import { Information } from './information';
import { SocialBar } from './socialBar';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <AppBar
      position="relative"
      color="secondary"
      style={{
        width: '100%',
        alignSelf: 'flex-end',
      }}
    >
      <Toolbar
        style={{
          height: '15em',
          alignItems: 'baseline',
          justifyContent: 'center',
        }}
      >
        <Stack width="100%" maxWidth="1200px" direction="column">
          <Grid container sx={{ width: '100%', marginTop: '20px' }}>
            <Grid
              item
              sx={{ height: '100%', width: '25%', justifyContent: 'left' }}
            >
              <Information />
            </Grid>
            <Grid
              item
              sx={{ height: '100%', width: '25%', justifyContent: 'left' }}
            >
              <HelpAndService />
            </Grid>
          </Grid>
          <Grid
            container
            sx={{ height: '100%', marginTop: '30px' }}
            maxWidth="1200px"
            alignItems="flex-end"
          >
            <Grid item sx={{ width: '50%' }}>
              <Typography color="inherit" fontSize="0.7rem">
                © {new Date().getFullYear()} {t('JungheinrichAG')}
              </Typography>
            </Grid>
            <Grid item sx={{ width: '50%' }}>
              <SocialBar />
            </Grid>
          </Grid>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
